import React, { useEffect } from "react";
import "./Home.scss";

import tldrBlogsLogoTrans from "../../assets/images/tldrBlogsLogoTrans.webp";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="homeContent">
      <Helmet>
        <title>tldr Blogs</title>
        <meta
          name="description"
          content="Blog site created for travel tips, tech stuff and others"
        />
        <meta name="keywords" content="Travel, Tips, Blog" />
        <meta property="og:title" content="tldr Blogs" />
        <meta
          property="og:description"
          content="Blog site created for travel tips, tech stuff and others"
        />
        <link rel="canonical" href="https://tldrblogs.com" />
      </Helmet>
      <section className="header">
        <div className="title">
          <img src={tldrBlogsLogoTrans} alt={"tldrBlogs"} className="logoImg" />
          <div className="description">
            Connecting the dots, one blog at a time.
          </div>
          <Link to="/blogs" className="getStartedButton">
            Explore <FaArrowRight size={20} className="arrow" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
